/*
 * Created on Sat Feb 17 2024
 * Author: Connor Doman
 */

import { addToggleHeaderButton } from "./toggle-wp-header";
import { prepareNavController, computeSubmenuHeights } from "./nav-controller";
import { setupScrollToTop } from "./scroll-to-top";

// Navigation toggle and submenu height
window.addEventListener("load", () => {
    prepareNavController();
    addToggleHeaderButton();
    computeSubmenuHeights();
    setupScrollToTop();
});

window.addEventListener("resize", () => {
    computeSubmenuHeights();
});



jQuery(function ($) {
    $('.image_slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrow: false,
        dots: false,
        variableWidth: true,
    });


    $('.content_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // speed: 15000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        variableWidth: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 995,
            settings: {
                variableWidth: false,
            }
          },
        ]
    }); 


    $('.content_slider2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        // speed: 15000,
        pauseOnHover: false,
        arrows: false,
        dots: false,
    }); 


    $('.content_slider3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // speed: 15000,
        pauseOnHover: false,
        arrows: false,
        dots: false,
        fade: true,
    }); 

    $('.banner-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        arrows: false,
        dots: false,
        fade: true,
    });

    function processStyle() {
            // Adding scroll event listener
            document.addEventListener('scroll', horizontalScroll);

            //Selecting Elements
            let sticky = document.querySelector('.sticky');
            let stickyParent = document.querySelector('.sticky-parent');

            let scrollWidth = sticky.scrollWidth;
            let verticalScrollHeight = stickyParent.getBoundingClientRect().height-sticky.getBoundingClientRect().height;

            //Scroll function 
            function horizontalScroll(){

                //Checking whether the sticky element has entered into view or not
                let stickyPosition = sticky.getBoundingClientRect().top;
                if(stickyPosition > 1){
                    return;
                }else{
                    let scrolled = stickyParent.getBoundingClientRect().top; //how much is scrolled?
                    sticky.scrollLeft =(scrollWidth/verticalScrollHeight)*(-scrolled)*0.85;
                
                }
            }
    }

    $(window).resize(function() {

        var width = $(window).width(); 
        var height = $(window).height(); 
        
        if ((width >= 500  ) && (height>=768)) {
        //do something
            processStyle()

        }
    });



    var width = $(window).width(); 
    var height = $(window).height(); 
    
    if ((width >= 500  ) && (height>=768)) {
    //do something
        processStyle()

    }
});

